'use client';

import classNames from 'classnames';
import { useEffect, useMemo, useState } from 'react';
import ReactMarkdown from 'react-markdown';

import {
  createMarkdownComponents,
  MARKDOWN_REHYPE_PLUGINS,
  MARKDOWN_REMARK_PLUGINS,
} from '~components/Markdown/markdownComponents';
import { subscribeToPreviewLiveValue } from '~store/PreviewLive';

import styles from './Markdown.module.scss';
import { PreviewMarkdownProps } from './PreviewMarkdown.types';

export function PreviewMarkdown({
  source,
  markdown,
  className,
}: PreviewMarkdownProps) {
  const [liveMarkdown, setLiveMarkdown] = useState<string>();

  const markdownComponents = useMemo(
    () => createMarkdownComponents(source),
    [source],
  );

  useEffect(
    () => subscribeToPreviewLiveValue(source, setLiveMarkdown),
    [source],
  );

  return (
    <>
      <ReactMarkdown
        className={classNames(styles.markdown, className)}
        remarkPlugins={MARKDOWN_REMARK_PLUGINS}
        rehypePlugins={MARKDOWN_REHYPE_PLUGINS}
        components={markdownComponents}
      >
        {liveMarkdown ?? markdown}
      </ReactMarkdown>
      <span aria-hidden data-strapi-source={source} data-strapi-markdown />
    </>
  );
}
